module.exports = __webpack_public_path__ + "static/media/login_banner.323fc89c.jpg";